import { FC } from "react";

interface RemoveImgArticleProps {
  size?: number;
  bgColor?: string;
  iconColor?: string;
}

const RemoveImgArticle: FC<RemoveImgArticleProps> = ({
  size = 38,
  bgColor = "#52575DB2",
  iconColor = "white",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="19" cy="19" r="19" fill={bgColor} />
    <path
      d="M24.8772 13.125L13.1289 24.8733"
      stroke={iconColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
    <path
      d="M13.1289 13.125L24.8772 24.8733"
      stroke={iconColor}
      strokeWidth={1.5}
      strokeMiterlimit={10}
    />
  </svg>
);

export default RemoveImgArticle;
